import React from "react";

type SectionCardProps = {
  title: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
};

export default function SectionCard({
  title,
  description,
  children,
  className,
}: SectionCardProps) {
  return (
    <div
      className={[
        "rounded-2xl bg-[#F5F5F5] ",
        "p-4",
        className ?? "",
      ].join(" ")}
    >
      <h3 className="m-0 text-[20px] font-semibold text-[#0c2624] leading-7">
        {title}
      </h3>

      {description && (
        <p className="mt-3 mb-0 text-sm text-[#0c2624] leading-5">
          {description}
        </p>
      )}

      <div className={description ? "mt-4" : "mt-3"}>{children}</div>
    </div>
  );
}
